import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import {
  CalibrationConfirmInvoiceApiResponse,
  CalibrationConfirmInvoiceModel
} from 'src/app/Interface/CalibrationConfirmInvoice_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationConfirmInvoiceService } from 'src/app/Service/CalibrationConfirmInvoice.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-letterrequestcustomer-factor2',
  templateUrl: './LetterrequestcustomerFactor2.component.html'
})
export class LetterrequestcustomerFactor2Component implements OnInit {
  loading = false;
  confirmingId: number | null = null;
  page = 1;
  Filter_title = '';
  factorConfirmFilter = 0;
  list: CalibrationConfirmInvoiceModel[] = [];
  selectedFactorReceipt: CalibrationConfirmInvoiceModel | null = null;
  confirmModalRef: any;

  constructor(
    private service: CalibrationConfirmInvoiceService,
    private alertifyService: AlertifyService,
    private modalService: BsModalService,
    private Nav_Service: NavService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.Nav_Service.CheckValidPage(2226).subscribe(
      () => this.getList(),
      () => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    );
  }

  getList(): void {
    this.loading = true;
    this.service.GetConfirmed(this.factorConfirmFilter)
      .pipe(finalize(() => this.loading = false))
      .subscribe(
        response => this.list = this.unwrap(response),
        () => this.alertifyService.ErrorMessage('دریافت لیست رسیدهای تایید نهایی شده با خطا مواجه شد.')
      );
  }

  Change_Filter_title(): void {
    this.page = 1;
  }

  onFactorConfirmFilterChange(): void {
    this.page = 1;
    this.getList();
  }

  isFactorConfirmed(item: CalibrationConfirmInvoiceModel): boolean {
    return !!(item.factorConfirmDate || item.factorConfirmDatePersian);
  }

  openFactorConfirmModal(template: TemplateRef<any>, item: CalibrationConfirmInvoiceModel): void {
    if (this.confirmingId !== null || this.isFactorConfirmed(item)) {
      return;
    }

    this.selectedFactorReceipt = item;
    this.confirmModalRef = this.modalService.show(template);
  }

  confirmFactor(): void {
    if (!this.selectedFactorReceipt || this.confirmingId !== null) {
      return;
    }

    const calibrationId = this.selectedFactorReceipt.calibrationId;
    this.confirmModalRef.hide();
    this.confirmingId = calibrationId;
    this.service.ConfirmFactor(calibrationId)
      .pipe(finalize(() => this.confirmingId = null))
      .subscribe(
        () => {
          this.alertifyService.SuccessMessage('فاکتور با موفقیت ثبت شد.');
          this.getList();
        },
        () => this.alertifyService.ErrorMessage('ثبت نهایی فاکتور با خطا مواجه شد.')
      );
  }

  showDetail(item: CalibrationConfirmInvoiceModel): void {
    this.router.navigate(
      ['/LetterrequestcustomerFactorForm', { id: item.calibrationId }],
      { state: { receipt: item } }
    );
  }


  private unwrap<T>(response: T[] | CalibrationConfirmInvoiceApiResponse<T[]>): T[] {
    if (Array.isArray(response)) {
      return response;
    }
    return response && Array.isArray(response.result) ? response.result : [];
  }
}
